import React, { Component } from 'react'
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import Moment from "moment/moment"

import EmployeeService from "../../../services/Employee.service"
import {formatCurrency, formatNumber, formatPercentage} from "../../../utils/jsUtils"

import VestTile from "../common/tiles/VestTile"
import TilesArea from "../common/tiles/TilesArea"

class VestsArea extends Component {

  constructor(props) {
    super(props);
  }

  onVestClick = (vest) => {
    this.props.onVestClick(vest);
  }

  getBadgeLabel(t, vest) {
    if (vest && vest.suspended) {
      return 'Suspended';
    }
    if (vest && vest.fed_override_tax !== this.props.defaultTaxRate && vest.fed_override_tax) {
      return t('StockAwards.VestsSection.FederaltaxBadge', {
        percent: formatPercentage(this.props.locale, vest.fed_override_tax)
      });
    }
    return null;
  }

  getVestQtyLabel(vest) {
    return vest.vested ? 'StockAwards.VestsSection.SharesVested' : 'StockAwards.VestsSection.SharesToVest';
  }

  getBrokers(t, broker, transOrVest) {
    if (broker) {
      return [broker];
    } else {
        return EmployeeService.getBrokersFromVest(t, this.props.awards, transOrVest);
    }
  }

  getFooterTopTrans(t, isRSU, transaction) {
    if (isRSU) {
      return t('StockAwards.VestsSection.SharesDeposited', {qty: transaction.net_shares === -1 ? '-' : transaction.net_shares});
    } else {
      return t('StockAwards.VestsSection.NetProceeds', {
        amount: transaction.net_proceeds === -1 ? '-' : formatCurrency(this.props.locale, transaction.net_proceeds)
      });
    }
  }

  getFractionalElection(t, vest) {
    if (this.props.fractionalMode && EmployeeService.hasFractionalEligibleVest(this.props.employee)) {
      return " (" + EmployeeService.getVestFractionalElectionText(t, this.props.employee, vest) + ")";
    } else {
      return "";
    }
  }

  render() {
    const {t, broker, vests, transactions, isRSU, footerMid, footerBottom} = this.props;
    const count = vests ? vests.length : transactions.length;
    const areaTitle = `${this.props.title} (${count})`;

    return (
      <TilesArea title={areaTitle}>
          {transactions && transactions.map((transaction) =>
            <VestTile
              date={Moment(transaction.transaction_date).format('LL')}
              info={isRSU ? t('StockAwards.VestsSection.SharesTransacted', {
                qty: formatNumber(this.props.locale, transaction.shares_transacted),
                award_type: isRSU ? 'RSUs' : 'Options'
              }) : t('StockAwards.VestsSection.SharesExercised', {qty: transaction.shares_transacted})}
              footerTop={this.getFooterTopTrans(t, isRSU, transaction)}
              footerMid={transaction.broker.name ? transaction.broker.name : ''}
              footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
              footerBottom={footerBottom ? footerBottom : this.getBrokers(t, broker, transaction)[1]}
              footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
              headerBadgeLabel={this.getBadgeLabel(t, null)}
              isClickable={true}
              obj={transaction}
              onTileClick={this.onVestClick}
            />
          )}

          {vests && vests.map((vest) =>
            <VestTile
              date={vest.suspended ? '' : Moment(vest.vest_date).format('LL')}
              info={t(this.getVestQtyLabel(vest), {
                qty: formatNumber(this.props.locale, vest.vest_shares),
                award_type: isRSU ? 'RSUs' : 'Options'
              })}
              footerTop={t("TaxTreatment." + vest.tax_election.code) + this.getFractionalElection(t, vest)}
              footerMid={footerMid ? footerMid : this.getBrokers(t, broker, vest)[0]}
              footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
              footerBottom={footerBottom ? footerBottom : this.getBrokers(t, broker, vest)[1]}
              footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
              headerBadgeLabel={this.getBadgeLabel(t, vest)}
              isClickable={true}
              obj={vest}
              onTileClick={this.onVestClick}
            />
          )}
      </TilesArea>
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  locale: state.employee.language,
  defaultTaxRate: state.configuration.default_tax_rate,
  fractionalMode: state.static_content.fractional_mode,
})

export default connect(mapState)(withTranslation('translationsV2')(VestsArea))
